import { render, staticRenderFns } from "./StaffDialog.vue?vue&type=template&id=57a2e26c&scoped=true&"
import script from "./StaffDialog.vue?vue&type=script&lang=js&"
export * from "./StaffDialog.vue?vue&type=script&lang=js&"
import style0 from "./StaffDialog.vue?vue&type=style&index=0&id=57a2e26c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a2e26c",
  null
  
)

export default component.exports